export default [
    {
        path: 'my-newsletters',
        name: 'my-newsletters',
        meta: {
            modules: ['newsletter', 'crm'],
            authentication_required: true,
            authorization_required: ['modules.newsletter', 'modules.crm'],
            translate: (t) => {
                return t('menu_points.my_newsletters').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'my-newsletters-list'},
        props: { own: true },
        children: [
            {
                path: '',
                name: 'my-newsletters-list',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t) => {
                        return t('menu_points.my_newsletters').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/newsletters/list.vue'),
                props: { own: true }
            },
            {
                path: 'create',
                name: 'my-newsletter-create',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: true }
            },
            {
                path: ':id(\\d+)',
                name: 'my-newsletter-edit',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: true },
            },
        ]
    },
    {
        path: 'my-mail-lists',
        name: 'newsletters-my-mail-lists',
        meta: {
            modules: ['newsletter', 'crm'],
            authentication_required: true,
            authorization_required: ['modules.newsletter', 'modules.crm'],
            translate: (t) => {
                return t('menu_points.my_mail_lists').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'newsletters-my-mail-lists-list'},
        props: { own: true },
        children: [
            {
                path: '',
                name: 'newsletters-my-mail-lists-list',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t) => {
                        return t('menu_points.my_mail_lists').ucFirst();
                    }
                },
                component: () => import('@/views/pages/newsletters/mail-lists/list.vue'),
                props: { own: true }
            },
            {
                path: 'create',
                name: 'newsletters-my-mail-list-create',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::mail_lists.mail_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/mail-lists/item.vue'),
                props: { own: true }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-my-mail-list-edit',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::mail_lists.mail_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/mail-lists/item.vue'),
                props: { own: true }
            },
        ]
    },
    {
        path: 'my-filters',
        name: 'newsletters-my-filters',
        meta: {
            modules: ['newsletter', 'crm'],
            authorization_required: ['modules.newsletter', 'modules.crm'],
            translate: (t) => {
                return t('menu_points.my_filters').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'newsletters-my-filters-list'},
        props: { own: true },
        children: [
            {
                path: '',
                name: 'newsletters-my-filters-list',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t) => {
                        return t('menu_points.my_filters').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/filters/list.vue'),
                props: { own: true }
            },
            {
                path: 'create',
                name: 'newsletters-my-filter-create',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::filters.filter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/filters/item.vue'),
                props: { own: true }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-my-filter-edit',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::filters.filter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/filters/item.vue'),
                props: { own: true }
            },
        ]
    },
    {
        path: 'my-periodicals',
        name: 'newsletters-my-periodicals',
        meta: {
            modules: ['newsletter', 'crm'],
            authentication_required: true,
            authorization_required: ['modules.newsletter', 'modules.crm'],
            translate: (t) => {
                return t('menu_points.my_periodicals').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'newsletters-my-periodicals-list'},
        props: { own: true },
        children: [
            {
                path: '',
                name: 'newsletters-my-periodicals-list',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t) => {
                        return t('menu_points.my_periodicals').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/periodicals/list.vue'),
                props: { own: true }
            },
            {
                path: 'create',
                name: 'newsletters-my-periodical-create',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::periodicals.periodical', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/periodicals/item.vue'),
                props: { own: true }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-my-periodical-edit',
                meta: {
                    modules: ['newsletter', 'crm'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter', 'modules.crm'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::periodicals.periodical', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/periodicals/item.vue'),
                props: { own: true }
            },
        ]
    },

    {
        path: '',
        name: 'newsletters-list',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.newsletters').ucFirst();
            },
        },
        component: () => import('@/views/pages/newsletters/newsletters/list.vue'),
    },
    {
        path: 'create',
        name: 'newsletter-create',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
        },
        component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
    },
    {
        path: ':id(\\d+)',
        name: 'newsletter-edit',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
        },
        component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
    },
    {
        path: 'all',
        name: 'all-newsletters',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.all_newsletters').ucFirst();
            },
        },
        component: () => import('@/views/pages/newsletters/newsletters/list.vue'),
        props: { locked: true }
    },

    {
        path: 'newsletters',
        name: 'newsletters-newsletters',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter_management').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        props: { own: false },
        redirect: { name: 'newsletters-newsletters-list'},
        children: [
            {
                path: '',
                name: 'newsletters-newsletters-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter_management').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/newsletters/list.vue'),
                props: { own: false },
            },
            {
                path: 'create',
                name: 'newsletters-newsletter-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: false },
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-newsletter-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: false },
            },
        ]
    },

    {
        path: 'mail-lists',
        name: 'newsletters-mail-lists',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.mail_lists').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        props: { own: false },
        redirect: { name: 'newsletters-mail-lists-list'},
        children: [
            {
                path: '',
                name: 'newsletters-mail-lists-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.mail_lists').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/mail-lists/list.vue'),
                props: { own: false }
            },
            {
                path: 'create',
                name: 'newsletters-mail-list-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::mail_lists.mail_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/mail-lists/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-mail-list-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::mail_lists.mail_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/mail-lists/item.vue'),
                props: { own: false }
            },
        ]
    },

    {
        path: 'email-lists',
        name: 'newsletters-email-lists',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.email_lists').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        props: { own: false },
        redirect: { name: 'newsletters-email-lists-list'},
        children: [
            {
                path: '',
                name: 'newsletters-email-lists-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.email_lists').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/email-lists/list.vue'),
                props: { own: false }
            },
            {
                path: 'create',
                name: 'newsletters-email-list-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::email_lists.email_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/email-lists/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-email-list-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::email_lists.email_list', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/email-lists/item.vue'),
                props: { own: false }
            },
        ]
    },
    {
        path: 'filters',
        name: 'newsletters-filters',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.filters').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        props: { own: false },
        redirect: { name: 'newsletters-filters-list'},
        children: [
            {
                path: '',
                name: 'newsletters-filters-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.filters').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/filters/list.vue'),
                props: { own: false }
            },
            {
                path: 'create',
                name: 'newsletters-filter-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::filters.filter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/filters/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-filter-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::filters.filter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/filters/item.vue'),
                props: { own: false }
            },
        ]
    },
    {
        path: 'periodicals',
        name: 'newsletters-periodicals',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.periodicals').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        props: { own: false },
        redirect: { name: 'newsletters-periodicals-list'},
        children: [
            {
                path: '',
                name: 'newsletters-periodicals-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.periodicals').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/periodicals/list.vue'),
                props: { own: false }
            },
            {
                path: 'create',
                name: 'newsletters-periodical-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::periodicals.periodical', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/periodicals/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-periodical-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::periodicals.periodical', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/periodicals/item.vue'),
                props: { own: false }
            },
            {
                path: ':id(\\d+)/queue-dates',
                name: 'newsletter-queue-dates',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.queue_dates').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/queue-dates/calendar.vue'),
            },
            {
                path: ':id(\\d+)/newsletters/create',
                name: 'newsletters-periodical-newsletter-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: false }
            },
            {
                path: ':periodical(\\d+)/queue-dates/:queue(\\d+)/newsletters/create',
                name: 'newsletters-periodical-queue-date-newsletter-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::newsletters.newsletter', 1)}).ucFirst()

                },
                component: () => import('@/views/pages/newsletters/newsletters/item.vue'),
                props: { own: false }
            },
        ]
    },
    {
        path: 'emails',
        name: 'newsletters-emails',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.emails').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'newsletters-emails-list'},
        children: [
            {
                path: '',
                name: 'newsletters-emails-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.emails').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/emails/list.vue'),
            },
            {
                path: 'create',
                name: 'newsletters-email-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::emails.email', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/emails/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-email-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::emails.email', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/emails/item.vue')
            },
        ]
    },
    {
        path: 'settings',
        name: 'newsletters-settings',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.settings').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'newsletters-settings-list'},
        children: [
            {
                path: '',
                name: 'newsletters-settings-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.settings').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/settings/list.vue'),
            },
            {
                path: 'create',
                name: 'newsletters-setting-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::settings.setting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/settings/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-setting-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::settings.setting', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/settings/item.vue')
            },
        ]
    },
    {
        path: 'domains',
        name: 'newsletters-domains',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.domains').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'newsletters-domains-list'},
        children: [
            {
                path: '',
                name: 'newsletters-domains-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.domains').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/domains/list.vue'),
            },
            {
                path: 'create',
                name: 'newsletters-domain-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::domains.domain', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/domains/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-domain-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::domains.domain', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/domains/item.vue')
            },
        ]
    },
    {
        path: 'senders',
        name: 'newsletters-senders',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.senders').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'newsletters-senders-list'},
        children: [
            {
                path: '',
                name: 'newsletters-senders-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.senders').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/senders/list.vue'),
            },
            {
                path: 'create',
                name: 'newsletters-sender-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::senders.sender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/senders/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-sender-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::senders.sender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/senders/item.vue')
            },
        ]
    },
    {
        path: 'sources',
        name: 'newsletters-sources',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.sources').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: {name: 'newsletters-sources-list'},
        children: [
            {
                path: '',
                name: 'newsletters-sources-list',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.sources').ucFirst();
                    },
                },
                component: () => import('@/views/pages/newsletters/sources/list.vue'),
            },
            {
                path: 'create',
                name: 'newsletters-source-create',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/sources/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'newsletters-source-edit',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['modules.newsletter'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/newsletters/sources/item.vue')
            },
        ]
    },
];